export const state = {
  totalNbNotification: null,
  // A key that the notifications will watch to see if they need to be refreshed
  notificationsKey: 0,
};

export const getters = {
  getNbTotalNotification: (state) => state.totalNbNotification,
};

export const mutations = {
  commitTotalNbNotification(state, nbTotalNotification) {
    state.totalNbNotification = nbTotalNotification;
  },
  commitNotificationsKey(state) {
    state.notificationsKey += 1;
  },
};

export default {
  namespaced: true,
  state,
  getters,
  mutations,
};
